import { connect } from 'react-redux'
import ServiceHolidayItem from '../../components/services/edit/holidays/ServiceHolidayItem'
import { actionCreators, removeHoliday } from '../../state/actions/services/index'
import { IHolidayItem, IStoreState } from '../../types/index'

const mapStateToProps = (state: IStoreState, ownProps: any): any => {
  return {
    holidayItem: ownProps.holidayItem
  }
}

const mapDispatchToProps = (dispatch: any) => {
  return {
    onRemoveClick: (id: string) => dispatch(removeHoliday(id)),
    onSetFrom: (holidayItemId: string, from: string) => dispatch(actionCreators.holidaysSetFrom(holidayItemId, from)),
    onSetUntil: (holidayItemId: string, until: string) =>
      dispatch(actionCreators.holidaysSetUntil(holidayItemId, until)),
    onSetDate: (holidayItemId: string, date: Date) => dispatch(actionCreators.holidaysSetDate(holidayItemId, date))
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ServiceHolidayItem)



// WEBPACK FOOTER //
// ./src/containers/services/ServiceHolidayItem.ts